import { render } from "./BuyParalleliums.vue?vue&type=template&id=77a943b9&scoped=true"
import script from "./BuyParalleliums.vue?vue&type=script&lang=js"
export * from "./BuyParalleliums.vue?vue&type=script&lang=js"

import "./BuyParalleliums.vue?vue&type=style&index=0&id=77a943b9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a943b9"]])

export default __exports__